import { QueryKey, useMutation } from '@tanstack/react-query';
import { IFileForm } from 'api/types';
import { AxiosInstance } from 'axios';
import { queryClient } from 'configs/queryClient';
import { useAxios } from 'context/AxiosContextProvider';

async function uploadFile(data: IFileForm, apiUrl: string, axios: AxiosInstance) {
  const formData = new FormData();
  // @ts-ignore
  formData.append('file', data.file.file as File);

  return await axios.post(apiUrl + '/confirmation', formData);
}

export default function useUploadFileMutation(apiUrl: string, invalidationKey: QueryKey) {
  const axios = useAxios();

  return useMutation({
    mutationFn: (data: IFileForm) => uploadFile(data, apiUrl, axios),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invalidationKey });
    },
  });
}
